export interface ConcatProps {
  form: Form
  setForm: SetFormProps
  fieldSetId: string
  disabled: boolean
  templateId: string
}

export type SetFormProps = (value: null | Form | ((prevState: Form) => Form)) => void

interface Form {
  id: string
  checked: boolean
  description: string
  fieldset_id: string
  governance_type: string
  name: string
  concatenation_governance: ConcatenationGovernance
}

interface ConcatenationGovernance {
  concatenation_governance_patterns: GovernanceField[]
  separator: string
}

export interface FieldOption {
  name: string
  id: string
}

export interface GovernanceField {
  field_id: string
  concatenation_list_id: number | null
  concatenation_list_column_id: number | null
  concatenation_field_id: string
  concatenation_field_name?: string
  precedence: number
}

export interface State {
  options: FieldOption[]
  searchResults: FieldOption[]
  searchTerm: string
  selected: GovernanceField[]
}

export enum ActionType {
  clearSearch = 'clearSearch',
  resetToInitialState = 'resetToInitialState',
  setSearchResults = 'setSearchResults',
  setSelected = 'setSelected',
}

export type Action =
  | {
      type: ActionType.clearSearch
      payload: {
        searchTerm: string
      }
    }
  | {
      type: ActionType.resetToInitialState
      payload: {
        selected: GovernanceField[]
      }
    }
  | {
      type: ActionType.setSearchResults
      payload: { searchTerm: string }
    }
  | {
      type: ActionType.setSelected
      payload: {
        fieldId: string
        checked: boolean
      }
    }
